import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import AuthContextProvier from "../context/AuthContextProvider";
import PasswordRecovery from "../pages/PasswordRecovery";
import Login from "../pages/Login";
import { SigninExternalCallback } from "../components/SigninExternalCallback";
import SuccessMessage from "../pages/SuccessMessage";
import ErrorMessage from "../pages/ErrorMessage";
import { Box } from "@mui/material";
import FirstAccess from "../pages/FirstAccess";
import { useContext } from "react";
import { MainContext } from "../../main/context/MainContextProvider";

export default function AuthRoutes() {
  const { user } = useContext(MainContext);
  return (
    <>
      <AuthContextProvier>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ height: "100%", width: "100%" }}
        >
          <Routes>
            {user && user?.passwordReseted ? (
              <>
                <Route path="nova-senha" element={<FirstAccess />} />
                <Route
                  path="nova-senha/sucesso"
                  element={<SuccessMessage />}
                ></Route>
                <Route
                  path="nova-senha/erro"
                  element={<ErrorMessage />}
                ></Route>
                <Route path="/*" element={<Navigate to={"/nova-senha"} />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Login />} />
                <Route path="recuperar-senha" element={<PasswordRecovery />} />
                <Route
                  path="signin-external-callback"
                  element={<SigninExternalCallback />}
                />
                <Route
                  path="recuperar-senha/sucesso"
                  element={<SuccessMessage />}
                ></Route>
                <Route
                  path="recuperar-senha/erro"
                  element={<ErrorMessage />}
                ></Route>

                <Route path="nova-senha" element={<FirstAccess />} />
              </>
            )}
          </Routes>
        </Box>
      </AuthContextProvier>
      <Outlet />
    </>
  );
}
